import React from 'react';

import styles from './Offline.module.scss';

export interface OfflineProps {
  isOffline: boolean;
}

const Offline = ({ isOffline }: OfflineProps) => {
  return isOffline ? (
    <div className={styles.offline}>
      <span className={styles.text}>No Internet Connection</span>
    </div>
  ) : (
    <></>
  );
};

export default Offline;
